export function getIntersectionCaseInsensitive(
  array1: Array<string>,
  array2: Array<string>
): Array<string> {
  const array1LowerCase = array1.map((element) => element.toLowerCase());
  const array2LowerCase = array2.map((element) => element.toLowerCase());
  return array1LowerCase.filter((element) => array2LowerCase.includes(element)) ?? [];
}
